export const iconFontAwesomeFoodBeverageCakeCandles = (
	<i className="fa-solid fa-cake-candles"></i>
);
